var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var Wallet = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 24 24" }),
        React.createElement("path", { d: "M23.46,6.17h-2V1.11a.54.54,0,0,0-.54-.53H3.08A3.08,3.08,0,0,0,0,3.91V20.67A3.12,3.12,0,0,0,3.08,24H23.46a.53.53,0,0,0,.53-.53V6.7A.53.53,0,0,0,23.46,6.17ZM3.08,1.65h17.3V6.17H3.08a2,2,0,0,1-2-2.26A2,2,0,0,1,3.08,1.65ZM22.93,17.34H19.64a2,2,0,0,1-2-2.26,2,2,0,0,1,2-2.26h3.29Zm0-5.58H19.64a3.07,3.07,0,0,0-3.08,3.32,3.07,3.07,0,0,0,3.08,3.33h3.29v4.52H3.08c-1.94,0-2-2-2-2.26V6.5a3.24,3.24,0,0,0,2,.74H22.93Z" })));
};
export default Wallet;
